








import {Component, Vue} from 'vue-property-decorator';
@Component({
  name:"IPost"
})
export default class IPost extends Vue{

}
